<div class="markdown-editor" [class.edit-mode]="!readonly">
  @if (!isReady) {
    <div class="loading-spinner">
      <cs-spinner></cs-spinner>
    </div>
  }
  @if (!readonly) {
    <div class="toolbar">
      <cs-icon-button [ngClass]="{'active': stateBold}" (mousedown)="$event.preventDefault()" (click)="handleBold()" icon="bold"></cs-icon-button>
      <cs-icon-button [ngClass]="{'active': stateItalic}" (mousedown)="$event.preventDefault()" (click)="handleItalic()" icon="italic"></cs-icon-button>
      <cs-icon-button [ngClass]="{'active': stateBullet}" (mousedown)="$event.preventDefault()" (click)="handleBullet()" icon="bullet-list"></cs-icon-button>
      <cs-icon-button [ngClass]="{'active': stateNumbered}" (mousedown)="$event.preventDefault()" (click)="handleNumbered()" icon="numbered-list"></cs-icon-button>
      <cs-icon-button [ngClass]="{'active': stateLink}" (mousedown)="$event.preventDefault()" (click)="handleLink()" icon="link"></cs-icon-button>
    </div>
  }
  <div class="editor-wrapper">
    <div class="editor" #editor (input)="handleInputChanged()" (keyup)="handleCaretMove()" (mouseup)="handleCaretMove()">
    </div>
  </div>
</div>